// MODULES
import React, { useState } from "react";
// IMAGES
import add from "../../assets/add.png";
import wallet from "../../assets/wallet-white.png";
import addWhite from "../../assets/add-white.png";
import visaWhite from "../../assets/visa-white.png";
import creditCard from "../../assets/credit-card.png";
import nextImg from "../../assets/right-caret.png";
// COMPONENTS
import TransactionRecord from "./transaction-record";
import Modal from "../app/Modal";
import CreditCardDetails from "./credit-card-details";

export default function Wallet() {
  const [topup, setTopup] = useState<boolean>(false);
  const [addCardModal, setAddCardModal] = useState<boolean>(false);
  const [step, setStep] = useState<number>(0);
  const [topupAmount, setTopupAmount] = useState<number | string>("");
  return (
    <div>
      <div className="flex items-center justify-between">
        <h1 className="font-semibold text-2xl">Wallet</h1>
        <div
          onClick={() => setAddCardModal(!addCardModal)}
          className="flex items-center space-x-2 cursor-pointer"
        >
          <div>
            <img src={add} alt="" className="w-4 h-4 md:w-5 md:h-5" />
          </div>
          <h1 className="text-base text-primary font-medium">
            Add payment method
          </h1>
        </div>
      </div>
      <div className="py-10 flex items-center justify-center w-[90%] overflow-x-scroll">
        <div className="rounded-[10px] bg-primaryBlack p-5 w-full md:w-[47%]">
          <div className="flex justify-between">
            <div className="flex items-center space-x-4 py-3">
              <div className="p-3 rounded-2xl bg-primary w-fit">
                <img src={wallet} alt="" className="w-6 h-6 mx-auto" />
              </div>
              <div>
                <h1 className="text-border text-[14px] font-medium tracking-wide">
                  Available balance
                </h1>
                <h2 className="font-semibold text-2xl text-white">NGN 2,500</h2>
              </div>
            </div>
            <div
              onClick={() => setTopup(!topup)}
              className="flex items-center space-x-2 cursor-pointer"
            >
              <div>
                <img src={addWhite} className="w-4 h-4" alt="" />
              </div>
              <h1 className="font-medium text-[14px] text-white">Top up</h1>
            </div>
          </div>
        </div>
        <div className="rounded-[10px] bg-primary p-5 md:w-[47%]">
          <div className="flex justify-between">
            <div className="flex items-center space-x-4 py-3 text-white">
              <div>
                <h1 className="text-[16px] font-medium tracking-wide">
                  Kemi Shola
                </h1>
                <h2 className="font-medium">..... ..... ..... 24532</h2>
              </div>
            </div>
            <div className="grid justify-items-end">
              <img src={visaWhite} className="w-[30%]" alt="" />
            </div>
          </div>
        </div>
      </div>
      <div className="my-10 border rounded-[10px] border-border">
        <div className="border-b border-border p-4">
          <h1 className="font-semibold text-lg md:text-2xl">
            Transaction History
          </h1>
        </div>
        <div>
          <div className="w-full">
            <div className="w-full my-5">
              <TransactionRecord
                title="Pickup Delivery"
                status="success"
                paymentMethod="Card Billing"
                date="May 20th"
                amount="4,000"
              />
              <TransactionRecord
                title="Pickup Delivery"
                status="failed"
                paymentMethod="Wallet"
                date="May 16th"
                amount="40,000"
              />
              <TransactionRecord
                title="Pickup Dispatch"
                status="failed"
                paymentMethod="Wallet"
                date="May 16th"
                amount="10,000"
              />
              <TransactionRecord
                title="Pickup Dispatch"
                status="success"
                paymentMethod="Wallet"
                date="May 17th"
                amount="5,000"
              />
            </div>
          </div>
        </div>
      </div>
      <div>
        {/* TOPUP MODAL  */}
        <Modal
          header="Top up your zap wallet"
          openModal={topup}
          setOpenModal={() => setTopup(!topup)}
        >
          <div className="mt-4">
            <div>
              <label htmlFor="topupAmount" className="secondary-text">
                Enter amount
              </label>
              <div className="input-field">
                <input
                  value={topupAmount}
                  onChange={(e) => setTopupAmount(e.target.value)}
                  name="topupAmount"
                  required
                  className="w-full"
                />
              </div>
            </div>
          </div>
          <div className="px-6">
            <div
              onClick={() => setTopup(!topup)}
              className="absolute bottom-6 w-full px-6 left-0"
            >
              <button className="w-full bottom-6 font-medium">Confirm</button>
            </div>
          </div>
        </Modal>

        {/* NEW CARD MODAL  */}
        <Modal
          header="Add payment method"
          openModal={addCardModal}
          setOpenModal={() => setAddCardModal(!addCardModal)}
        >
          <div className="my-4">
            {step === 0 && (
              <div
                onClick={() => setStep(1)}
                className="flex items-center justify-between cursor-pointer"
              >
                <div className="flex items-center space-x-2">
                  <img src={creditCard} alt="" className="w-[10%]" />
                  <h1 className="font-semibold text-lg text-paragraph">
                    Credit or debit card
                  </h1>
                </div>
                <div>
                  <img src={nextImg} alt="" className="w-[25%] mx-auto" />
                </div>
              </div>
            )}
            {step === 1 && <CreditCardDetails />}
          </div>
        </Modal>
      </div>
    </div>
  );
}
